"use client";

import * as Sentry from "@sentry/nextjs";
import {useEffect, useState} from "react";
import {ExclamationTriangleIcon} from "@heroicons/react/24/outline";
import {useRouter} from "next/navigation";

// sentry wizard default setup page
// export default function GlobalError({error}: { error: Error & { digest?: string } }) {
//     useEffect(() => {
//         Sentry.captureException(error);
//     }, [error]);

export default function GlobalError({error, reset}: { error: Error; reset: () => void }) {
    const router = useRouter();

    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
            <div className="max-w-3xl w-full text-center bg-white rounded-2xl shadow-xl p-8">
                <div className="inline-flex justify-center space-x-2">
                    <h1 className="inline-flex items-center text-2xl font-extrabold text-danger">
                        خطا رخ داده است
                    </h1>
                    <ExclamationTriangleIcon className="size-8 text-danger mb-2"/>
                </div>
                <p className="text-gray-800 text-center mb-6 text-lg leading-relaxed">
                    متاسفانه یک خطای غیرمنتظره رخ داده. تیم ما در حال بررسی است و به‌زودی مشکل رفع خواهد شد
                </p>

                <div className="flex w-full justify-center gap-x-4">
                    <a
                        href="/"
                        className="w-full  md:w-1/3 px-6 py-3 bg-primary rounded-lg hover:bg-black text-white border border-gray-400 shadow-md inline-block text-center"
                    >
                        بازگشت به صفحه اصلی
                    </a>
                    {/*<button*/}
                    {/*    onClick={reset}*/}
                    {/*    className="w-1/2 px-6 py-3 bg-primary text-white font-semibold rounded-lg hover:bg-blue-700 border border-gray-400 shadow-md hover:cursor-pointer"*/}
                    {/*>*/}
                    {/*    تلاش دوباره*/}
                    {/*</button>*/}
                </div>
            </div>
        </div>
    );

    // sentry wizard default setup page
    // return (
    //   <html>
    //     <body>
    //       {/* `NextError` is the default Next.js error page component. Its type
    //       definition requires a `statusCode` prop. However, since the App Router
    //       does not expose status codes for errors, we simply pass 0 to render a
    //       generic error message. */}
    //       <NextError statusCode={0} />
    //     </body>
    //   </html>
    // );
}